export const baseHref = '/';
